<template>
  <component
    :is="layoutName"
    :materials="materials"
    @ads:click="adsOnClick"
    @ads:view="adsOnView"
    @ads:entry="adsOnEntry"
  ></component>
</template>

<script>
import CMainShapePc from "./layout/CMainShapePc.vue";
import CMainShapeMobile from "./layout/CMainShapeMobile.vue";
import { LAYOUT_NAME } from "@/adsmart-ui/settings/boards/type103.js";

export default {
  name: "AdsType103",
  components: {
    [LAYOUT_NAME.C_MAIN_SHAPE_PC]: CMainShapePc,
    [LAYOUT_NAME.C_MAIN_SHAPE_MOBILE]: CMainShapeMobile
  },
  props: {
    materials: {
      type: Array,
      required: true
    },
    layoutName: {
      type: String,
      default: ""
    }
  },
  methods: {
    adsOnClick(linkHref, materialIndex) {
      this.$emit("ads:click", linkHref, materialIndex);
    },
    adsOnView(materialIndex) {
      this.$emit("ads:view", materialIndex);
    },
    adsOnEntry(materialIndex) {
      this.$emit("ads:entry", materialIndex);
    }
  }
};
</script>

<style lang="scss">
@import "~scss/reset.scss";
@import "~scss/fontFamilyPC.scss";
</style>
